var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisibilityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.885742 9C1.60254 5.16 5.02409 2.25 9.13574 2.25C13.2474 2.25 16.6682 5.16 17.3857 9C16.6689 12.84 13.2474 15.75 9.13574 15.75C5.02409 15.75 1.6033 12.84 0.885742 9V9ZM9.13574 12.75C10.1469 12.75 11.1167 12.3549 11.8318 11.6517C12.5468 10.9484 12.9485 9.99456 12.9485 9C12.9485 8.00544 12.5468 7.05161 11.8318 6.34835C11.1167 5.64509 10.1469 5.25 9.13574 5.25C8.12454 5.25 7.15476 5.64509 6.43973 6.34835C5.7247 7.05161 5.32301 8.00544 5.32301 9C5.32301 9.99456 5.7247 10.9484 6.43973 11.6517C7.15476 12.3549 8.12454 12.75 9.13574 12.75ZM9.13574 11.25C8.52902 11.25 7.94715 11.0129 7.51813 10.591C7.08912 10.169 6.8481 9.59674 6.8481 9C6.8481 8.40326 7.08912 7.83097 7.51813 7.40901C7.94715 6.98705 8.52902 6.75 9.13574 6.75C9.74246 6.75 10.3243 6.98705 10.7533 7.40901C11.1824 7.83097 11.4234 8.40326 11.4234 9C11.4234 9.59674 11.1824 10.169 10.7533 10.591C10.3243 11.0129 9.74246 11.25 9.13574 11.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityIcon);
export default __webpack_public_path__ + "static/media/VisibilityIcon.787e48fc39ac36b4d20ec842b7df3c3f.svg";
export { ForwardRef as ReactComponent };